<app-expansion-panel (isExpandedChange)="toggleExpanded()">
    <span
        class="font-medium text-xl"
        header>
        {{ 'associatedEntities' | transloco }}</span
    >
    @if (hasBeenExpanded()) {
        <div content>
            @for (layerRelation of layerRelations(); track layerRelation.tableName) {
                <app-related-entities-list
                    [layerRelation]="layerRelation"
                    [sourceEntityId]="sourceEntityId()"
                    [sourceGeometry]="sourceGeometry()"
                    [sourceLayerId]="sourceLayerId()"
                    [sourceTableName]="sourceTableName()" />
            }
        </div>
    }
</app-expansion-panel>
